export function calculateAge(
  dateOfBirth: string,
  referenceDate: Date = new Date()
): number {
  const dob = new Date(dateOfBirth);
  const yearDiff = referenceDate.getFullYear() - dob.getFullYear();

  const monthDiff = referenceDate.getMonth() - dob.getMonth();
  const dayDiff = referenceDate.getDate() - dob.getDate();

  // Birthday has not yet occurred this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    return yearDiff - 1;
  }

  return yearDiff;
}
